package com.eladfinish.bible.contest.platform

actual fun isStartupSystemPromptPending(): Boolean = false
